import "./ShapeFilters.scss";
import { Card, Icon, IconName } from "@repo/ping-design";
import { ShapeFilterType } from "../../../ts-types/mapsTypes";

type ShapeFilterTool = {
  id: string;
  label: string;
  iconName: IconName;
  type: ShapeFilterType;
};

type ShapeFiltersProps = {
  onSelect: (tool: { label: string; iconName: IconName }) => void;
  onApplyShapeFilter: (shapeType: ShapeFilterType) => void;
};

export const SHAPE_FILTER_TOOLS: ShapeFilterTool[] = [
  {
    id: "polygonal-shape-filter",
    label: "Polygon",
    iconName: "Pentagon",
    type: ShapeFilterType.POLYGON,
  },
  {
    id: "rectangular-shape-filter",
    label: "Rectangle",
    iconName: "Square",
    type: ShapeFilterType.RECTANGLE,
  },
  {
    id: "circular-shape-filter",
    label: "Circle",
    iconName: "Circle",
    type: ShapeFilterType.CIRCLE,
  },
];

const ShapeFilters = ({ onSelect, onApplyShapeFilter }: ShapeFiltersProps) => {
  return (
    <Card className="ShapeFilters">
      {SHAPE_FILTER_TOOLS.map((tool) => (
        <button
          key={tool.id}
          onClick={() => {
            onSelect({ label: tool.label, iconName: tool.iconName });
            onApplyShapeFilter(tool.type);
          }}
          className="ShapeFilters__Item"
        >
          <Icon iconName={tool.iconName} size={16} />
          <span>{tool.label}</span>
        </button>
      ))}
    </Card>
  );
};

export default ShapeFilters;
